import { useEffect, useState } from "react";
import { Menu, X, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Results", href: "#results" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div
          className={`flex items-center justify-between rounded-2xl px-5 py-3 transition-all duration-300 ${
            scrolled ? "glass" : "bg-transparent"
          }`}
        >
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-2 group"
          >
            <div className="relative">
              <div className="w-9 h-9 rounded-xl bg-[#FF5722] flex items-center justify-center text-black font-bold shadow-[0_0_20px_-5px_rgba(255,87,34,0.6)]">
                <Zap className="w-5 h-5" strokeWidth={2.5} />
              </div>
            </div>
            <span className="text-lg font-bold tracking-tight text-white">
              RH<span className="text-[#FF5722]">.</span>Technology
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}-link`}
                className="px-4 py-2 text-sm font-medium text-zinc-300 hover:text-white transition-colors rounded-lg hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Button
              data-testid="nav-cta-button"
              className="bg-[#FF5722] hover:bg-[#FF7043] text-black font-semibold rounded-xl px-5 shadow-[0_0_30px_-8px_rgba(255,87,34,0.6)]"
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            >
              Start Campaign
            </Button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white p-2"
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div data-testid="mobile-menu" className="md:hidden mt-2 glass rounded-2xl p-4 flex flex-col gap-2">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 text-sm text-zinc-300 hover:text-white rounded-lg hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
            <Button
              className="bg-[#FF5722] hover:bg-[#FF7043] text-black font-semibold mt-2"
              onClick={() => { setOpen(false); document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }); }}
            >
              Start Campaign
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
